<on-page-title
    [title]="'payment.floatingLicensesHistory.title' | translate"
    icon="fa-users"
></on-page-title>

<div class="row align-items-end mb-3">
    <div class="col-md-4">
        <div class="form-label">
            {{ 'payment.floatingLicensesHistory.dateLabel' | translate }}
        </div>
        <on-form-date-picker
            [(ngModel)]="selectedDate"
            (ngModelChange)="onDateChange()"
        ></on-form-date-picker>
    </div>
    <div class="col-md-8 text-end" *ngIf="hasLoadedOnce && !isLoading">
        <span class="licenses-count">
            {{
                'payment.floatingLicensesHistory.total'
                    | translate: { nb: snapshots.length }
            }}
        </span>
    </div>
</div>

<on-loading *ngIf="isLoading"></on-loading>

<div *ngIf="!isLoading && hasLoadedOnce">
    <div *ngIf="snapshots.length === 0" class="alert alert-info">
        {{ 'payment.floatingLicensesHistory.empty' | translate }}
    </div>
    <table class="table table-striped" *ngIf="snapshots.length > 0">
        <thead>
            <tr>
                <th>
                    {{ 'payment.floatingLicensesHistory.user' | translate }}
                </th>
                <th>
                    {{ 'payment.floatingLicensesHistory.date' | translate }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let snapshot of snapshots">
                <td>{{ snapshot.Username }}</td>
                <td>{{ snapshot.DateOfCount | date }}</td>
            </tr>
        </tbody>
    </table>
</div>
